import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type createFreeTextSelfCheckElementButton_CreateFreeTextSelfCheckElementMutation } from "@relay/createFreeTextSelfCheckElementButton_CreateFreeTextSelfCheckElementMutation.graphql";
import { CREATE_FREE_TEXT_SELF_CHECK_ELEMENT_MUTATION } from "./create-free-text-self-check-element-button.graphql";
import { type CreateFreeTextSelfCheckElementButtonProps } from "./create-free-text-self-check-element-button.types";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

export const CreateFreeTextSelfCheckElementButton = ({
	eLearningContentNodeId,
}: CreateFreeTextSelfCheckElementButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [createFreeTextSelfCheckElement, isCreatingFreeTextSelfCheckElement] =
		useMutation<createFreeTextSelfCheckElementButton_CreateFreeTextSelfCheckElementMutation>(
			CREATE_FREE_TEXT_SELF_CHECK_ELEMENT_MUTATION,
		);

	return (
		<Button
			disabled={isCreatingFreeTextSelfCheckElement}
			tooltip={t("educationalOffer.createFreeTextSelfCheckTooltip")}
			icon={EpicIcons.PENCIL}
			onClick={() => {
				createFreeTextSelfCheckElement({
					variables: {
						input: {
							eLearningContentId: eLearningContentNodeId,
							title: t("educationalOffer.newElement"),
							text: "",
							enableSolutionReveal: false,
						},
					},
					updater: setDraft,
				});
			}}
		/>
	);
};
